import { render, staticRenderFns } from "./QuickMenuCollectionMultiselect.vue?vue&type=template&id=22d9d05d&"
import script from "./QuickMenuCollectionMultiselect.vue?vue&type=script&lang=js&"
export * from "./QuickMenuCollectionMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports